export const routePaths = {
  root: '',
  dashboard: 'dashboard',
  startPersonalInfo: 'start-personal-info',
  itrProfile: 'itr-profile',
  personalDetails: 'personal-details',
  newReturnInfo: 'new-return-info',
  marital: 'marital',
  dependents: 'dependents',
  completeDetails: 'complete-details',
  partnerpersonalInfo: 'partner-info',
  busniessDetails: 'business-details',
  businessInfo: 'info',
  businessRevenue: 'revenue',
  businessExpenses: 'expenses',
  mailingDetails: 'mailing-details',
  infoSummary: 'info-summary',
  startReturn: 'start-return',
  signup: 'signup',
  login: 'login',
  verifyEmail: 'verifyEmail',
  emailVerified: 'emailVerified',
  forgotPassword: 'forgotPassword',
  passwordVerified: 'passwordVerified',
  resetPassword: 'resetPassword',
  welcome: 'welcome',
  itrSlips: 'itr-slips',
  t3StatementOfTrust: 't3-statement-of-trust',
  t5008StatementOfSecurities: 't5008-statement-of-securities',
  t4aOasOldAgeSecurity: 't4a-oas-old-age-security',
  t4apCppQppBenefits: 't4ap-cpp-qpp-benefits',
  t4eBenefits: 't4e-employment-insurance-benefits',
  rc210Cwb: 'rc210-cwb',
  t5007Benefits: 't5007-benefits',
  rc62UCCB: 'rc62-uccb',
  t4rifRegisteredRetirement: 't4rif-registered-retirement',
  t4rspRrspIncome: 't4rsp-income',
  t5StatementOfInvestment: 't5-statement-of-investment',
  t4StatementOfRemuneration: 't4-statement-of-remuneration',
  t4aStatementOfPension: 't4a-statement-of-pension',
  t4psStatementOfEmployeeProfit: 't4ps-statement-of-employee-profit',
  t4arcaArrangement:
    'T4A-RCA-distributions-from-a-retirement-compensation-arrangement',
  T5006RegisteredLabour:
    'T5006-registered-labour-sponsored-venture-capital-corporation-shares',
  foreignIncome: 'foreign-income',
  t10PensionAdjustment: 't10-pension-adjustment',
  t2202Tuition: 't2202-tution',
  selfEmploymentIncome: 'self-employment-income',
  businessVehicleExpenses: 'business-vehicle-expenses',
  workRelatedVehicleExpenses: 'work-vehicle-expenses',
  t1139Form: 't1139-form',
  advertising: 'advertising',
  entertainment: 'entertainment',
  wages: 'wages',
  doubtfulAccount: 'doubtful-accounts',
  otherExpenses: 'other-expenses',
  commercialInsurance: 'commercial-insurance',
  licensesTaxes: 'licenses-taxes',
  businessRelated: 'business-related',
  interestMaintenance: 'interest-maintenance',
  officeSupplies: 'office-supplies',
  bankingFeesAdvice: 'banking-fees-advice',
  taxesRent: 'taxes-rent',
  utilitiesBusiness: 'utilities-business',
  personalVehicleExpenses: `personal-vehicle-expenses`,
  workExpenses: `work-expenses`,
  vehiclesummary: `vehicle-summary`,
  businessIncome: 'business-income',
  selfBusinessIncome: 'self-business-income',
  checklistScreen: 'checklist-screen',
  medicalSlipDeduction: 'medical-slip-deduction',
  employmentStatusProfile: 'employment-status-profile',
  otherEmploymentIncome: 'other-employment-income',
  fixedAssets: 'fixed-assets',
  capitalCostAllowance: 'capital-cost-allowance',
  uccBalances: 'ucc-balances',
  additionDisposition: 'addition-disposition',
  homeForWork: 'home-for-work',
  homeUseForWork: 'home-use-for-work',
  homeYouUseForWork: 'home-you-use-for-work',
  homeExpenses: 'home-expenses',
  selfEmploymentRevenue: 'self-employment-revenue',
  sellProductBought: 'sell-product-bought',
  reservesDeducted: 'reserves-deducted',
  clergyResidenceDeduction: 'clergy-residence-deduction',
  clergyResidenceDeduction2: 'clergy-residence-deduction2',
  wageLossReplacement: 'wage-loss-replacement',
  transportEmployee: 'transport-employee',
  tripSummary: 'trip-summary',
  shortHaulTrip: 'short-haul-trip',
  longHaulTrip: 'long-haul-trip',
  repayments: 'repayments',
  workBusiness: 'work-business',
  partnerDetails: 'partner-details',
  aboutYourPartnership: 'about-your-partnership',
  expensesYourPartnership: 'expenses-partnership',
  equityPartnership: 'equity-partnership',
  incomeEarnedWebsite: 'earned-website',
  employementExpenses: 'employment-expenses',
  additionalCppQpp: 'additional-cpp-qpp',
  gstRebate: 'gst-rebate',
  deferredStock: 'deferred-stock',
  employeeProfitSharing: 'employee-profit-sharing',
  categoryWorkType: 'category-work-type',
  yearEndAdjustment: 'year-end-adjustment',
  donationSlipDeduction: 'donation-slip-deduction',
  retirementSavingForm: 'retirement-saving-form',
  myProfile: 'profile',
  changePassword: 'change-password',
  privacyPolicy: 'privacy-policy',
  termsCondition: 'terms-condition',
  payment: 'payment',
  pricingPlan: 'pricing-plan',
  congratulation: 'congratulation',
  paymentSuccess: 'payment-success',
  filingHub: 'filing-hub',
  paymentSummary: 'payment-summary',
  itrProvincial: 'itr-provincials',
  provincialInfo: 'info',
  provincialProfile: 'profile',
  propertyTax: 'property-tax',
  trilliumBenfit: 'trillium-benefit',
  paymentInfo: 'payment-info',
  trilliumBenefitApply: 'trillium-benefit-apply',
  tSlip: 't-slip',
  t101Slip: 't101-slip',
  t5013Slip: 't5013-slip',
  educationTax: 'education-tax',
  employmentTax: 'employment-tax',
  startItrPayment: 'start-payment',
  trainingTax: 'training-tax',
  opportunitiesFund: 'opportunities-fund',
  climateIncentive: 'climate-action-incentive',
  creditsForCai: 'credits-for-cai',
  creditNaForCai: 'credits-na-for-cai',
  caiSummary: 'cai-summary',
  ontarioTaxSummary: 'ontario-tax-summary',
  reviewTaxSummary: 'review-tax-summary',
  previousReturns: 'previous-returns',
  admin: 'admin',
  filingSuccess: 'filing-success',
  userManagement: 'users',
  craInfo: 'cra-info',
  fishingIncomeExpenses: 'fishing-income-expenses',
  farmingIncomeExpenses: 'farming-income-expenses',
  agristabilityAgriinvestParticipant: 'agri-stability-invest-participant',
  agristabilityAgriinvestProfile: 'agri-stability-invest-profile',
  investmentExpenses: 'investment-expenses',
  interestExpenses: 'interest-expenses',
  carryingCharges: 'carrying-charges',
  taxOnSplitIncome: 'tax-on-split-income',
  taxSplitIncome: 'tax-split-income',
  taxAdjustedIncome: 'tax-adjusted-income',
  rentalProperty: 'rental-property',
  rentalProfile: 'rental-profile',
  employmentExpensesIntro: 'employment-expenses-intro',
  employmentExpensesProfile: 'employment-expenses-profile',
  EmploymentExpensesMethodComponent: 'employment-expenses-method',
  motorVehicleExpenses: 'motor-vehicle-expenses',
  rebatePropertyService: 'gst-hst-rebate',
  employeeRelatedDriving: 'employee-related-driving',
  pdfSummary: 'pdf-summary',
  income: 'income',
  rrsp: 'rrsp',
  rrspProfile: 'rrsp-profile',
  amateurAthleteTrust: 'amateur-athlete-trust',
  saskatchewanPension: 'saskatchewan-pension',
  usForeignRetirementPlan: 'us-foreign-retirement-plan',
  lifeLongLearningPlanProfile: 'lifelong-learning-plan-Profile',
  transferRrspPrpp: 'transfer-rrsp',
  unusedRrspContribution: 'unused-rrsp-contribution',
  refundRrsp: 'refund-rrsp',
  registerPensionPlan: 'registered-pension-plan',
  rrspCalculator: 'rrsp-calculator',
  rrspDeductionLimit: 'deduction-limit',
  rrspContributionSummary: 'rrsp-contribution-summary',
  carryForwardRegisterPension: 'carry-forward-register',
  prppContributionSummary: 'prpp-contribution-summary',
  homeBuyersPlanProfile: 'home-buyers-plan-profile',
  paymentProfile: 'payment-profile',
  donationProfile: 'donation-profile',
  charitableDonationCarriedForward: 'charitable-donation-carried-forward',
  charitableDonation: 'charitable-donation',
  charitableDonationSummary: 'charitable-donation-summary',
  charitableDonationReceipt: 'charitable-donation-receipt',
  repaymentFederalCovid: 'repayment-federal-covid',
  unionProfessionalMember: 'union-professional-member',
  digitalNewsSubscription: 'digital-news-subscription',
  homeAccessibilityExpense: 'home-accessibility-expense',
  politicalContribution: 'political-contribution',
  foreignTax: 'foreign-tax',
  foreignTaxCredits: 'foreign-tax-credits',
  foreignTaxSummary: 'foreign-tax-summary',
  paidTaxInstalment: 'paid-tax-instalment',
  movingExpenseSummary: 'moving-expense-summary',
  movingProfile: 'moving-profile',
  initialMovingExpense: 'initial-moving-expense',
  movingExpenseCarriedForward: 'moving-expense-carried-forward',
  movingExpenseProfileForward: 'expenses-carried-forward',
  movingProfileFarDidYouMoved: 'far-did-you-move',
  reasonOfMoving: 'reason-of-moving',
  saleOfYourOldHouse: 'sale-of-your-old-house',
  detailToMoveComponent: 'detail-move',
  allowableMovingExpense: 'allowable-moving-expense',
  newMovingExpenses: 'new-moving-expenses',
  eligibleIncomeAtNewLocation: 'eligible-income-at-new-location',
  disabilitySupportInfo: 'disability-support-info',
  disabilitySupportPayment: 'disability-support-payment',
  disabilityAmount: 'disability-amount',
  medicalExpenseProfile: 'medical-expense-profile',
  studentProfile: 'student-profile',
  unusedTuitionEducation: 'unused-tuition-education',
  otherDeductionIntro: 'other-deduction-intro',
  eligibleEducatorTaxCredit: 'eligible-educator-tax-credit',
  northernResidentDeductionIntro: 'northern-resident-deduction-intro',
  northernResidentDeduction: 'northern-resident-deduction',
  northernResidentDeductionTrips: 'northern-resident-deduction-trips',
  additionalResidencyAmount: 'additional-residency-amount',
  volunteerFirefighterRescueService: 'volunteer-firefighter-rescue-service',
  otherDeduct: 'other-deduct',
  additionalDeduction: 'additional-deduction',
  additionalTaxAccumulatedResp: 'additional-tax-resp',
  additionalTaxIncomePayment: 'additional-tax-income-payment',
  // yourProvincialProfile: 'provincial-profile',
  lossesProfile: 'losses-profile',
  allowableBusinessInvestmentLosses: 'allowable-business-investment-losses',
  allowableBusinessInvestment: 'allowable-business-investment',
  nonCapitalLossesCarryForwards: 'non-capital-losses-carry-forwards',
  nonCapitalLossesBeingClaimed: 'non-capital-losses-being-claimed',
  restrictedFarmingLossCarryForwards: 'restricted-farming-loss-carry-forwards',
  restrictedFarmingLossesBeingClaimed:
    'restricted-farming-losses-being-claimed',
  farmingFishingLossCarryForwards: 'farming-fishing-loss-carry-forwards',
  farmingFishingLossBeingClaimed: 'farming-fishing-loss-being-claimed',
  listedPersonalPropertyLossesCarryForward:
    'listed-personal-property-losses-carry-forward',
  listedPersonalPropertyLossesBeingClaimed:
    'listed-personal-property-losses-being-claimed',
  netCapitalLossCarryForwards: 'net-capital-loss-carry-forwards',
  netCapitalLossesBeingClaimed: 'net-capital-loss-being-claimed',
  limitedPartnerShip: 'limited-partner-ship',
  nonCapitalLossCarrybacks: 'non-capital-loss-carrybacks',
  farmingFishingLossCarrybacks: 'farming-fishing-loss-carrybacks',
  lppLossCarrybacks: 'lpp-loss-carrybacks',
  netCapitalLossCarrybacks: 'net-capital-loss-carrybacks',
  restrictedFarmLossCarrybacks: 'restricted-farm-loss-carrybacks',
  yourProvincialProfile: 'your-provincial-profile',
  albertaProfile: 'alberta-profile',
  britishColumbiaProfile: 'british-columbia-profile',
  manitobaProfile: 'manitoba-profile',
  newBrunswickProfile: 'new-brunswick-profile',
  newfoundlandLabrador: 'newfoundland-labrador-profile',
  princeEdwardIslandProfile: 'prince-edward-profile',
  lossesProfileSummary: 'losses-profile-summary',
  novaScotiaProfile: 'nova-scotia-profile',
  carryForwardonCapitalLosses: 'carry-forwards-capital-gain',
  saskatchewanProfile: 'saskatchewan-profile',
};
